module.exports = __webpack_public_path__ + "static/standalone-a9a2a6e1ed1aeb78dc3fd4643fc69349.svg";